import USER_TYPES from '@/constants/authorization/user-types'
import store from '@/store'

const hide = () => !store.getters['pos/isModuleEnabled'] || !store.getters['subscription/isAddonPurchased']('ok_pos')

export default [
  {
    title: 'pos.pos',
    svgIcon: 'icon-pos',
    userTypes: [USER_TYPES.BRANCH_ADMIN],
    hide,
    children: [
      {
        title: 'pos.preview',
        route: 'admin:pos:preview',
        svgIcon: 'icon-pos-preview',
        userTypes: [USER_TYPES.BRANCH_ADMIN],
        hide,
      },
      {
        title: 'pos.register-terminals',
        route: 'admin:pos:terminals',
        svgIcon: 'icon-pos-register-terminal',
        userTypes: [USER_TYPES.BRANCH_ADMIN],
        hide,
      },
      {
        title: 'pos.cashier-sessions',
        route: 'admin:pos:sessions',
        svgIcon: 'icon-cashier',
        userTypes: [USER_TYPES.BRANCH_ADMIN],
        hide,
      },
      {
        title: 'pos.pos-settings',
        route: 'admin:pos:settings',
        svgIcon: 'icon-settings',
        userTypes: [USER_TYPES.BRANCH_ADMIN],
        hide,
      },
    ],
  },

]
